const DayHourTimeZone = Object.freeze({
  GMT: 'GMT',
  LOCAL: 'LOCAL'
})
export default DayHourTimeZone
export type DayHourTimeZoneStrings = typeof DayHourTimeZone[keyof typeof DayHourTimeZone]
// RESERVE BELOW
